// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"888":"db3f1cb2","975":"115ff22c"}[chunkId] + ".chunk.js");